<template>
  <div
    data-test="campsite-favourite-button"
    class="favourite-link"
    :class="{ favourite: isFavourite, desktop: $isDesktop }"
  >
    <pu-modal
      :use-portal="true"
      :modal-hash="`favourite-form-modal-${campsiteId}`"
      :class="{ desktop: $isDesktop }"
      class="favourite-add-form-modal"
      modal-class="favourite-add-form-modal"
    >
      <template #default="{ closeModal }">
        <favourite-add-form
          :campsite-id="campsiteId"
          :campsite-name="campsiteName"
          @process-done="closeModal"
        />
      </template>

      <template #modal-trigger>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill-rule="evenodd"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="1.41421"
          clip-rule="evenodd"
          viewBox="0 0 132 122"
        >
          <path
            class="favourite-heart"
            stroke-width="8.82"
            d="M65.504 21.74c6.46-9.67 15.429-18.403 31.221-17.17 16.167 1.265 28.839 15.353 30.011 31.96 1.015 14.389-4.282 23.425-10.892 30.639-13.171 14.373-26.912 28.304-41.145 42.524-2.46 2.459-5.772 7.597-8.953 7.659-2.485.049-5.208-3.305-7.746-6.075-11.143-12.16-22.265-23.35-33.883-34.864-4.311-4.272-9.799-9.605-13.069-14.262-4.215-6.003-7.252-14.179-6.535-25.092C5.626 20.094 18.388 5.967 34.039 4.57c16.253-1.448 24.829 6.978 31.465 17.17"
          />
          <path
            class="tick-path"
            stroke-width="13.54053"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            d="M42 63c8 2 14 6 20 13 10-17 15-26 28-41"
          />
        </svg>
        <template v-if="isFavourite">
          <translate class="sr-only"> Unfavourite </translate>
        </template>
        <template v-else>
          <translate class="sr-only"> Favourite </translate>
        </template>
      </template>
    </pu-modal>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useFavouritesStore } from '~/stores/useFavouritesStore'

const props = defineProps<{
  campsiteId: string
  campsiteName?: string
}>()

const favStore = useFavouritesStore(usePinia())

const isFavourite = computed(() => {
  return favStore.favourites[props.campsiteId] !== undefined
})
</script>

<style>
.favourite-link {
  display: inline-block;
  top: 0.2em;
  position: relative;
  z-index: 2;
  cursor: pointer;
}

.favourite-link svg {
  width: 1.4em;
  height: auto;
}

.tick-path {
  fill: none;
  stroke: white;
  stroke-dasharray: 100;
  stroke-dashoffset: 100;
  transition: stroke-dashoffset 0.1s ease-out;
}

.favourite .tick-path {
  opacity: 1;
  stroke-dashoffset: 0;
}

.favourite-heart {
  fill: none;
  stroke: white;
}

.favourite .favourite-heart {
  fill: var(--colour-red);
  stroke: var(--colour-red);
}

.favourite-link.desktop svg {
  width: 1.6em;
  height: auto;
}

.favourite-add-form-modal .modal-trigger-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.15);
  border-radius: 0.5em;
}

.favourite-link.cs-favourite .favourite-add-form-modal .modal-trigger-wrapper {
  padding: 0.35em;
}

.favourite-link.sr-favourite .favourite-add-form-modal .modal-trigger-wrapper {
  padding: 0.35em;
}

.favourite-add-form-modal button {
  width: 100%;
}

.add-new-favourites-list-modal.modal-container {
  bottom: 0 !important;
  z-index: 100 !important;
}

.add-new-favourites-list-modal .modal-body {
  height: auto !important;
}

.add-new-favourites-list-modal .modal-footer {
  padding: 2em 1em;
}

.add-new-favourites-list-modal .button-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1em;
  margin-top: 3em;
}

/* desktop & tablet */
.desktop.add-new-favourites-list-modal.modal-container {
  bottom: auto !important;
}
</style>
